(ns common.dispatcher
  (:require [clojure.string :as str]
            [common.db.config :as conf]
            [common.queries.http :as qhttp]
            [common.re-frame :as cr]
            [viesti.frontend.core :as vf]))

(defn dispatcher-url []
  (let [api-url (:apiUrl (conf/get-config))]
    (str (str/replace api-url #"/$" "") "/dispatch")))

(defn start
  ([] (start nil))
  ([options]
   (vf/init!
    (merge
     {:uri (dispatcher-url)
      :authorize (fn [request]
                   (let [token @(cr/uncached-subscribe [:resource.user/token])]
                     (cond-> request token (assoc-in [:headers "Authorization"] token))))}
     options))))

(defn dispatch
  "Dispatch version that just returns a promise resolving to the
  query result, no re-frame integration, useful for TSQ queries."
  [event]
  (qhttp/post (dispatcher-url)
              {:body event}))
